module.exports = __webpack_public_path__ + "static/img/2.9917ec62.jpg";